// removed by extract-text-webpack-plugin
module.exports = {"category-color":"category-color","filled":"filled"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/category-color/category-color.style.sass
// module id = F1Zx
// module chunks = 0